import { render, staticRenderFns } from "./TheHeaderNavItem.vue?vue&type=template&id=70b8595c&scoped=true&"
import script from "./TheHeaderNavItem.vue?vue&type=script&lang=js&"
export * from "./TheHeaderNavItem.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderNavItem.vue?vue&type=style&index=0&id=70b8595c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b8595c",
  null
  
)

export default component.exports